import useApi, { ApiOptions } from '../base/useApi';
import HospitalHeaderDTO from '@src/adapters/dto/hospital/HospitalHeaderDTO';

interface Params {
  action: 'ACCEPT' | 'REJECT';
  hospitalJoinRequestId: string;
  linkToConsultantId?: string;
  roles?: string[];
  registrationNumber?: string;
}

interface Result {
  items: HospitalHeaderDTO[];
}

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/hospital/join-request/status',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useHospitalJoinRequestLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useHospitalJoinRequestLazy;
